export enum Roles {
    SuperAdmin = 1,
    SystemManager = 2,
    SystemUser = 3,
    ClientManager = 4,
    Manager = 6,
    ClientUser = 5,
    User = 7,
    UnassignedUser = 8,
    Abstractor = 9
}